import React, { useContext, useState, useEffect } from "react";
import * as styles from "./Cafetera.module.scss";
import FirstVideoCafetera from "./FirstVideoCafetera/FirstVideoCafetera";
import TextSectionCafetera from "./TextSectionCafetera/TextSectionCafetera";
import SecondVideoCafetera from "./SecondVideoCafetera/SecondVideoCafetera";
import PortaFiltro from "./PortaFiltro/PortaFiltro";
import CafeteraBotones from "./CafeteraBotones/CafeteraBotones";
import Caracteristicas from "./Caracteristicas/Caracteristicas";
import img from "../../images/img_big.png";
import imgmobile from "../../images/img_big-mobile.png";
import PreguntasFrecuentasCafetera from "./PreguntasFrecuentasCafetera/PreguntasFrecuentasCafetera";
import SecondaryNav from "../SecondaryNav/SecondaryNav";
import { getAllCategories } from "../../services/Categories/getAllCateogories";
import { AppContext } from "../../context/AppContext";

const Cafetera = () => {
  const { country } = useContext(AppContext);

  const paises = [
    {
      id: 1,
      name: "Argentina",
    },
    {
      id: 5,
      name: "Bolivia",
    },
    {
      id: 3,
      name: "Chile",
    },
    {
      id: 4,
      name: "Paraguay",
    },
    {
      id: 2,
      name: "Uruguay",
    },
  ];

  const [categories, setCategories] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    getAllCategories(country)
      .then((receivedCategories) => {
        if (receivedCategories && receivedCategories.length > 0) {
          setCategories(receivedCategories);
        } else {
          console.log("No se recibieron categorías");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // Detect if the device is mobile
    const checkIsMobile = () => {
      return window.innerWidth <= 768; // Adjust this breakpoint as needed
    };

    const handleResize = () => {
      setIsMobile(checkIsMobile());
    };

    handleResize(); // Check on initial render
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const patternCategory = categories?.filter(
    (categories) => categories.patternCategory === null
  );

  const childCategory = categories?.filter(
    (categories) => categories.patternCategory !== null
  );

  return (
    <section className={styles.main_container}>
      <div className={styles.container_second_nav}>
        <SecondaryNav
          Name={"Cafetera"}
          Stock={"Stock"}
          modelo={"PE-CE5007IXN"}
        />
      </div>
      <FirstVideoCafetera
        paises={paises}
        categories={categories}
        patternCategory={patternCategory}
        childCategory={childCategory}
      />
      <TextSectionCafetera />
      <SecondVideoCafetera />
      <PortaFiltro />
      <CafeteraBotones />
      <Caracteristicas />
      <img
        className={styles.container_image}
        src={isMobile ? imgmobile : img}
        alt="imagen de cafetera"
      />
      <PreguntasFrecuentasCafetera
        paises={paises}
        categories={categories}
        patternCategory={patternCategory}
        childCategory={childCategory}
      />
    </section>
  );
};

export default Cafetera;
